<template>
    <a-table 
      :size="type==='ugc'?'middle':'small'" :class="type==='ugc'?'ux-issue-table ugc-gameplay-table-children':'ux-issue-table'" :scroll="type==='ugc'?{y:500}:{}"
      :loading="loading" :pagination="type==='ugc'?false:pagination" :columns="dataColumns" :data-source="data" ref="ux-issue-table" bordered>
      <span slot="obstacleHeader">
        阻碍等级
        <a-popover title="阻碍等级说明" placement="rightBottom" arrow-point-at-center>
          <template slot="content">
            <img src="@/assets/img/obstacle.png" style="width:1200px; height: 500px;"/>
          </template>
          <span style="color:#9a9a9a"><a-icon type="info-circle" /></span>
        </a-popover> 
      </span>
      <div slot="remark" slot-scope="text" class="remark-text">
        <span class="remark-content" v-html="text"></span>
      </div>
      <div slot="obstacle" slot-scope="text,record">
        <span :class="`meta-span`" :style="{ backgroundColor: obstacles[text]?obstacles[text].color:undefined }">{{text}}</span>
      </div>
      <div slot="designer" slot-scope="text,record" class="remark-text">
        <span v-if="!(editItem && editItem.issue_id === record.issue_id) ||  editType!=='designer'" class="remark-content">{{text}}</span>
        <a-textarea v-if="editItem && editItem.issue_id === record.issue_id && editType==='designer'" v-model="editItem.designer" placeholder="请输入" size="small" rows="1" />
      </div>
      <div slot="solution" slot-scope="text,record" class="remark-text">
        <span v-if="!(editItem && editItem.issue_id === record.issue_id) ||  editType!=='item'" class="remark-content">{{text}}</span>
        <a-textarea v-if="editItem && editItem.issue_id === record.issue_id && editType==='item'" v-model="editItem.solution" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入" size="small" />
      </div>
      <div slot="progress" slot-scope="text,record">
        <span v-if="!(editItem && editItem.issue_id === record.issue_id) ||  editType!=='item'" :class="`meta-span`" :style="{ backgroundColor: progresses[text]?progresses[text].color:undefined }">{{text}}</span>
        <a-select v-if="editItem && editItem.issue_id === record.issue_id && editType==='item'" v-model="editItem.progress" style="width: 120px" size="small" placeholder="请选择进度">
        <a-select-option v-for="p in progressOptions" :key="p.id" :value="p.id" >{{p.label}}</a-select-option>
        </a-select>
      </div>
      <div slot="verification" slot-scope="text,record" class="remark-text">
        <span v-if="!(editItem && editItem.issue_id === record.issue_id) || editType!=='verification'" class="remark-content">{{text}}</span>
        <a-textarea v-if="editItem && editItem.issue_id === record.issue_id && editType==='verification'" v-model="editItem.verification" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入" size="small" />
      </div>
      <div slot="operator" slot-scope="record">
        <a-button type="link" v-if="!(editItem && editItem.issue_id === record.issue_id)"  size="small" @click="handleEdit(record, 'item')">编辑</a-button>
        <a-button type="link" v-if="!(editItem && editItem.issue_id === record.issue_id)"  size="small" @click="handleEdit(record, 'designer')">编辑回复人</a-button>
        <a-button type="link" v-if="!(editItem && editItem.issue_id === record.issue_id)"  size="small" @click="handleEdit(record, 'verification')">编辑验证</a-button>
        <template v-if="editItem && editItem.issue_id === record.issue_id">
          <a-button type="link" size="small" @click="handleConfirm(record)">确定</a-button>
          <a-button type="link" :style="{color: '#888'}" size="small" @click="handleCancel()">取消</a-button>
        </template>
      </div>          
    </a-table>
  </template>
  
  <script>
  import { isNil } from 'lodash';
import moment from 'moment';
import { message } from 'ant-design-vue';
  
  export default {
    name: 'issueTable',
    props: [
      'type',
      'data',
      'progressOptions',
      'meta',
    ],  
    components: {
    },
    computed: {
      obstacles() {
        const _colors = {}
        this.meta.obstacle.forEach(row=>{
          _colors[row.value] = row
        })
        return _colors
      },
      progresses() {
        const _colors = {}
        this.meta.progress.forEach(row=>{
          _colors[row.value] = row
        })
        return _colors
      },
      dataColumns() {
        let columns = this.type === 'ugc'?
          [
            // { title: '位置', dataIndex: 'position', width: 80 },
            { width: 90, dataIndex: 'obstacle', slots: { title: 'obstacleHeader' }, scopedSlots: { customRender: 'obstacle' }, sorter: (prev, next) => (this.obstacles[prev.obstacle]?this.obstacles[prev.obstacle].order:0) - (this.obstacles[next.obstacle]?this.obstacles[next.obstacle].order:0)},
            { title: '问题描述', dataIndex: 'description', scopedSlots: { customRender: 'remark' }, width: '50%'  },
            { title: '反馈频次', width: 90, dataIndex: 'frequency', sorter: (prev, next) => (prev.frequency - next.frequency) },
            { title: '对应功能解决', dataIndex: 'solution', scopedSlots: { customRender: 'solution' }, width: '30%' },
            // { title: '决策者回复', dataIndex: 'delivery', width: 200, scopedSlots: { customRender: 'delivery' } },
            { title: '当前进度', dataIndex: 'progress', width: 140, scopedSlots: { customRender: 'progress' }, sorter: (prev, next) => ((this.progresses[prev.progress]?this.progresses[prev.progress].order:0) - (this.progresses[prev.progress]?this.progresses[next.progress].order:0)) },
            { title: '回复时间', dataIndex: 'format_update_time', width: 90, sorter: (prev, next) => (prev.update_time - next.update_time) },
            { title: '反馈周期', dataIndex: 'format_dt', width: 64, sorter: (prev, next) => (prev.time - next.time) },
            { title: '版本', dataIndex: 'version', width: 90, sorter: (prev, next) => (prev.version - next.version)},
            { title: '操作', scopedSlots: { customRender: 'operator' }, width: 64 },
          ] : [
          { title: '模式', dataIndex: 'mode', width: 80, slots: { title: 'XXX'}},
          { dataIndex: 'obstacle', slots: { title: 'obstacleHeader' }, width: 90, scopedSlots: { customRender: 'obstacle' }, sorter: (prev, next) => (prev.obstacleOrder - next.obstacleOrder) },
          { title: '问题描述', dataIndex: 'description', scopedSlots: { customRender: 'remark' }, width: '45%' },
          { title: '反馈频次', dataIndex: 'frequency', width: 64, sorter: (prev, next) => (prev.frequency - next.frequency) },
          { title: '来源', dataIndex: 'type', width: 64 },
          { title: '对应功能解决', dataIndex: 'solution', scopedSlots: { customRender: 'solution' }, width: '30%' },
          // { title: '决策者回复', dataIndex: 'delivery', width: 200, scopedSlots: { customRender: 'delivery' } },
          { title: '当前进度', dataIndex: 'progress', width: 140, scopedSlots: { customRender: 'progress' }, sorter: (prev, next) => (prev.progressOrder - next.progressOrder) },
          { title: '回复人', dataIndex: 'designer', width: 90, scopedSlots: { customRender: 'designer' }},
          { title: '回复时间', dataIndex: 'format_update_time', width: 90, sorter: (prev, next) => (prev.update_time - next.update_time) },
          { title: '反馈时间', dataIndex: 'format_time', width: 64, sorter: (prev, next) => (prev.time - next.time) },
          { title: '操作', scopedSlots: { customRender: 'operator' }, width: 64 },
        ]
        const ues = ['hzchenchen7@corp.netease.com', 'hwjn1487@corp.netease.com', 'hzzengguofen@corp.netease.com', 'hzliuying1@corp.netease.com', 'hzhujiasheng@corp.netease.com', 'liuming04@corp.netease.com', 'hzzhangxinhui1@corp.netease.com', 'zhanghaoyu07@corp.netease.com', 'yingyixin@corp.netease.com', 'chenlinyi01@corp.netease.com', 'koonweichung@corp.netease.com', 'duanyiwen@corp.netease.com', 'guozhouzhiyi@corp.netease.com']
        if(ues.indexOf(this.$store.state.user.email) >= 0) {
          columns.splice(columns.length-1, 0, {title: '效果验证', dataIndex: 'verification', width: '20%', scopedSlots: { customRender: 'verification' }})
        }
        return columns
      }
    },
    data() {
      return {
        loading: false,
        pagination: {
          pageSize: 30,
          showSizeChanger: true,
          showQuickJumper: true,
          size: "middle",
        },
        editItem: undefined,
        editType: 'item'
        
      }
    },
    methods: {
      handleEdit(item, type) {
        this.editItem = item;
        this.editType = type
      },
      handleCancel() {
        this.editItem = undefined;
      },
      handleConfirm() {
        let params = {
          id: this.editItem.issue_id,
          type: this.editType,
        }
        if(this.editType === 'item') {
          params = {
            ...params,
            progress: isNil(this.editItem.progress) ? '' : this.editItem.progress,
            solution: isNil(this.editItem.solution) ? '' : this.editItem.solution,
            designer: isNil(this.editItem.designer) ? '' : this.editItem.designer,
          }
          if(params.solution.trim() == '' && ['bug', '2', '3'].indexOf(this.editItem.obstacle)>=0) {
            message.error('对应功能解决方案必填')
            return
          }
        }
        else if(this.editType === 'verification') {
          params = {
            ...params,
            verification: isNil(this.editItem.verification) ? '' : this.editItem.verification,
          }
        }
        else if(this.editType === 'designer') {
          params = {
            ...params,
            designer: isNil(this.editItem.designer) ? '' : this.editItem.designer,
          }
        }
        this.$service.addData(`${this.$service.api.project.query_fixed_module}experience_issue_update/`, params).then(d => {
          this.$message.success(`更新问题 ${this.editItem.issue_id} 成功`);
          this.editItem = undefined;
          const issueList = this.data.map((issue) =>
            issue && issue.issue_id === params.id
              ? this.editType==='item'?{
                  ...issue,
                  progress: params.progress,
                  solution: params.solution,
                  update_time: d.update_time,
                  designer: d.designer,
                  format_update_time: !d.update_time ? '-' : moment(d.update_time).format('MM/DD HH:mm'),

                }:{
                  ...issue,
                  verification: params.verification,
                }
              : issue
          );
          
          this.$emit('update', issueList);
          console.log(issueList)
        }).catch(err => {
          console.log(err)
          this.$message.error(`更新问题 ${this.editItem.issue_id} 失败`);
        })
      },
      getDownloadUrl(text) {
          const BOM = '\uFEFF'
          // Add BOM to text for open in excel correctly
          if (window.Blob && window.URL && window.URL.createObjectURL) {
              const csvData = new Blob([BOM + text], { type: 'text/csv;charset=utf-8;' })
              return URL.createObjectURL(csvData)
          }
          return `data:text/csv;charset=utf-8,${BOM}${encodeURIComponent(text)}`
      },
      exportToExcel(filename) {
        const tHeader = [];
        this.dataColumns.forEach((f)=>{
          tHeader.push(f.title)
        })
        const data = [tHeader]
        if(this.data) {
          this.data.forEach((d)=>{
            let row = []
            this.dataColumns.forEach((field)=> {
              let v = d[field.dataIndex]
              row.push(typeof(v)== 'string'?'"'+v.replace(/"/g, '""')+'"':v)
              console.log(typeof(v)== 'string'?'"'+v.replace(/"/g, '""')+'"':v)
            })
            data.push(row)
          })
        }
        let text = []
        data.forEach((row)=>{
            text.push(row.join(','))
        })
        const link = document.createElement('a')
        link.download = `${filename?filename:'数据'}.csv`
        link.href = this.getDownloadUrl(text.join('\n'))
        const evObj = new MouseEvent('click', { view: window, bubbles: true, cancelable: true })
        link.dispatchEvent(evObj)
      },
    }
  }
  </script>
  
  <style lang="less">
  .ux-issue-table {
    .meta-span {
      display: inline-block;
      border-radius: 6px;
      padding: 1px 6px;
      font-size: 12px;
      background-color: #c4c4c4;
    }
    .remark-text {
      white-space: pre-line;
      text-align: left;
    }
    .remark-content {
      display: -webkit-box;
      // -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
      max-width: 100%;
      // overflow: hidden;
      // text-overflow: ellipsis;
    }
    .filter-wrap {
      display: flex;
      flex-wrap: wrap;
      
    }
    .filter {
      padding-bottom: 12px;
    }
    .ant-table-small>.ant-table-content>.ant-table-body {
      margin: 0;
    }
    .ant-table-thead > tr {
      background:#f2f2f2;
    }  
    .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
      padding: 8px 3px
    }
    .ant-table-thead > tr > th .ant-table-column-sorter {
      display: table-cell;
      vertical-align: middle;
      .ant-table-column-sorter-inner {
        margin-left: 0;
      }
    }
  }
  .ugc-gameplay-table-children {
      
      .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th, .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
        padding: 5px;
      }
    }
  </style>